import {
  Home,
  EmojiEvents,
  Search,
  Groups,
  BarChart,
  Sports,
  Business,
  LocationOn,
  Person,
  Gavel,
  Settings,
  Star,
  Info,
  type SvgIconComponent,
} from '@mui/icons-material';

export interface NavItemConfig {
  id: string;
  path: string;
  label: string;
  icon: SvgIconComponent;
}

export interface NavSection {
  id: string;
  title: string;
  items: NavItemConfig[];
}

/** Основные разделы: нижняя панель (mobile) и верхняя панель (desktop). */
export const primaryNavItems: NavItemConfig[] = [
  { id: 'home', path: '/', label: 'Главная', icon: Home },
  { id: 'tournaments', path: '/tournaments', label: 'Турниры', icon: EmojiEvents },
  { id: 'search', path: '/search', label: 'Поиск', icon: Search },
];

interface MenuSectionsParams {
  isAuthenticated: boolean;
  showSports: boolean;
}

export const resolveMenuSections = ({ isAuthenticated, showSports }: MenuSectionsParams): NavSection[] => {
  const sections: NavSection[] = [];

  if (isAuthenticated) {
    sections.push({
      id: 'mine',
      title: 'Моё',
      items: [
        { id: 'my-tournaments', path: '/tournaments?mine=1', label: 'Мои турниры', icon: EmojiEvents },
        { id: 'my-teams', path: '/profile#teams', label: 'Мои команды', icon: Groups },
        { id: 'favorites', path: '/profile#favorites', label: 'Избранное', icon: Star },
      ],
    });
  }

  const catalogs: NavItemConfig[] = [
    { id: 'teams', path: '/teams', label: 'Команды', icon: Groups },
    { id: 'players', path: '/players', label: 'Игроки', icon: Person },
    { id: 'venues', path: '/venues', label: 'Площадки', icon: LocationOn },
    { id: 'organizations', path: '/organizations', label: 'Организации', icon: Business },
    { id: 'officials', path: '/officials', label: 'Судьи', icon: Gavel },
  ];
  if (showSports) {
    catalogs.push({ id: 'sports', path: '/sports', label: 'Виды спорта', icon: Sports });
  }
  sections.push({ id: 'catalogs', title: 'Каталоги', items: catalogs });

  sections.push({
    id: 'stats',
    title: 'Статистика',
    items: [{ id: 'analytics', path: '/analytics', label: 'Аналитика и рейтинги', icon: BarChart }],
  });

  sections.push({
    id: 'app',
    title: 'Приложение',
    items: [
      ...(isAuthenticated ? [{ id: 'settings', path: '/settings', label: 'Настройки', icon: Settings }] : []),
      { id: 'about', path: '/settings#about', label: 'О приложении', icon: Info },
    ],
  });

  return sections;
};

export const isPathActive = (itemPath: string, pathname: string): boolean => {
  const path = itemPath.split(/[?#]/)[0];
  if (path === '/') {
    return pathname === '/';
  }
  return pathname === path || pathname.startsWith(`${path}/`);
};
